import {
  CLEAR_EXTERNAL_ACCOUNT,
  GET_ACC_LIST_SUCCESS,
  GET_BRIVO_CLEANUP_USERS_SUCCESS,
  GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS,
  GET_EXTERNAL_ACCOUNT_SUCCESS,
  GET_EXTERNAL_LINKS_LIST_SUCCESS,
  GET_LIST_OF_APTEXX_ACCOUNTS_SUCCESS,
  GET_LIST_OF_CLICKPAY_ACCOUNTS_SUCCESS,
  GET_LIST_OF_EE_ACCOUNTS_SUCCESS,
  GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_SUCCESS,
} from '../actionConstants';

import { toSentenceCase } from '../utils';

const defaultState = {
  account: {},
  paymentsAccounts: {
    listOfExternalAccounts: {},
    listOfAptexxAccounts: {},
    listOfClickpayAccounts: {},
    buildingPaymentsAccount: {},
  },
  accessControlAccounts: {
    listOfBrivoAccounts: {},
    listOfComelitAccounts: {},
    listOfSmartairAccounts: {},
    listOf2nAccounts: {},
    listOfAkuvoxAccounts: {},
    listOfBmxAccounts: {},
    listOfDormakabaAccounts: {},
    listOfLyazonAccounts: {},
    listOfZervAccounts: {},
    listOfSaltoAccounts: {},
    listOfKeyscanAccounts: {},
  },
  camerasAccounts: {
    listOfEEAccounts: {},
  },
  customIntegrations: {
    externalLinksList: {},
  },
  brivoCleanupUsers: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_EXTERNAL_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: action.res.data,
      };
    case CLEAR_EXTERNAL_ACCOUNT:
      return {
        ...state,
        account: {},
      };
    case GET_LIST_OF_EXTERNAL_PAYMENTS_ACCOUNTS_SUCCESS:
      return {
        ...state,
        paymentsAccounts: {
          ...state.paymentsAccounts,
          listOfExternalAccounts: action.res.data,
        },
      };
    case GET_LIST_OF_APTEXX_ACCOUNTS_SUCCESS:
      return {
        ...state,
        paymentsAccounts: {
          ...state.paymentsAccounts,
          listOfAptexxAccounts: action.res.data,
        },
      };
    case GET_LIST_OF_CLICKPAY_ACCOUNTS_SUCCESS:
      return {
        ...state,
        paymentsAccounts: {
          ...state.paymentsAccounts,
          listOfClickpayAccounts: action.res.data,
        },
      };
    case GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS:
      return {
        ...state,
        paymentsAccounts: {
          ...state.paymentsAccounts,
          buildingPaymentsAccount: {
            ...state.paymentsAccounts.buildingPaymentsAccount,
            [action.buildingId]: action.res.data,
          },
        },
      };
    case GET_LIST_OF_EE_ACCOUNTS_SUCCESS:
      return {
        ...state,
        camerasAccounts: {
          ...state.camerasAccounts,
          listOfEEAccounts: action.res.data,
        },
      };
    case GET_EXTERNAL_LINKS_LIST_SUCCESS:
      return {
        ...state,
        customIntegrations: {
          ...state.customIntegrations,
          externalLinksList: action.res.data,
        },
      };
    case GET_ACC_LIST_SUCCESS:
      return {
        ...state,
        accessControlAccounts: {
          ...state.accessControlAccounts,
          [`listOf${toSentenceCase(action.accountType)}Accounts`]:
            action.res.data,
        },
      };
    case GET_BRIVO_CLEANUP_USERS_SUCCESS:
      return {
        ...state,
        brivoCleanupUsers: action.res.data,
      };
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
